var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('iframe',{staticClass:"ifram",attrs:{"src":`/api/static/html/${_vm.page}`,"frameborder":"0"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }